import { URLS } from '../../../constants';
import apiClient from '../../client';

const productivityApi = {
  productivity: ({
    profileUserId,
    profileOrgId,
    currentTime,
  }: {
    profileUserId: any;
    profileOrgId: any;
    currentTime: any;
  }) =>
    apiClient.post(URLS.productivity, {
      data: {
        profileUserId,
        profileOrgId,
        currentTime,
      },
    }),
  upcommingProgressNote: ({
    profileUserId,
    profileOrganizationId,
    currentTime,
  }: {
    profileUserId: string;
    profileOrganizationId: string;
    currentTime: string;
  }) =>
    apiClient.post(URLS.upcommingProgressNote, {
      data: {
        profileUserId,
        profileOrganizationId,
        currentTime,
      },
    }),
};

export default productivityApi;
